(function() { 'use strict';
    angular.module('mso.registration')
        .constant('ReferenceDataMap', [
            {
                when: 'register',
                valuesets: ['rdOccupancyStatusCode', 'rdAddressTypeCode', 'RDCountryCode', 'rdMonthCode', 'RDIndividualTitleCode', 'RDIntermediaryType', 'RDMemorableQuestions', 'RDValidateBankAccountResponse', 'RDBDMRelationship'],
                messages: ['2174', '2179', '2180', '2181', '2182', '2183', '4336', '3001', '3002', '3003', '3004', '3005', '3006', '3007', '3008', '3009', '3010', '4133', '4200', '4203', '4215', '4221', '4222', '4223', '4224', '4243', '4342', '4344', '4345', '3025', '4412', '4413', '4414', '4415', '4416','4417', '4418', '4475', '4499', '4577', '4773', '4830', '5033', '5034'],
                parameters: ['p2250', 'p3120', 'p6079', 'p6084', 'p6085', 'p6030', 'p6088', 'p6089', 'p6146', 'p6147', 'p6148', 'p6149', 'p6150', 'p6151', 'p6153', 'p6213', 'p6259', 'p6260', 'p6261', 'p6304', 'p6305', 'p6362', 'p6482', 'p6521', 'p6640', 'p6641', 'p6653']
            },
            {
                when: 'register-success',
                valuesets: [],
                messages: ['4212', '4213', '4214'],
                parameters: ['p6030', 'p6084', 'p6085']
            },
            {
                when: 'pending-requests',
                valuesets: [],
                messages: ['4226', '4227'],
                parameters: [ ]
            },
            {
                when: 'directives/mso-address-editor',
                valuesets: [],
                messages: [ ],
                parameters: [ ]
            },
            {
                when: 'review-request/:pendingId',
                valuesets: ['RDIntermediaryType', 'RDIndividualTitleCode'],
                messages: ['3001', '4237', '4238', '4239'],
                parameters: [ ]
            },
            {
                when: 'register-complete/:tokenId',
                valuesets: ['RDMemorableQuestions'],
                messages: ['3001','3009','4203','4343','4215','4335','4346', '3025', '4228', '4499', '4759', '4760', '4761'],
                parameters: ['p6142', 'p6145', 'p6030', 'p6259', 'p6260', 'p6261', 'p6554']
            },
            {
                when: 'register-complete-success',
                valuesets: [],
                messages:['4235', '4212'],
                parameters: ['p6030']
            },
            {
                when: 'register-complete-expired',
                valuesets: [],
                messages:['4278'],
                parameters: ['p6084']
            },
            {
                when: 'register-complete-deactivated',
                valuesets: [],
                messages:['4855'],
                parameters: ['p6084']
            },
            {   when:'#Header#',
                valuesets : [],
                messages : [ ],
                parameters : ['p6256', 'p6257']
            },
            {
                when: 'session-expiry-service',
                valuesets: [],
                messages: [ ],
                parameters: ['p3055']
            }
        ]
    );
})();
